<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="icons/chevron/up-thin" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <polygon id="bg" points="0 0 16 0 16 16 0 16" />
      <g
        id="icons/chevron/down-thin"
        transform="translate(8.000000, 8.000000) rotate(180.000000) translate(-8.000000, -8.000000) "
      >
        <polygon id="bg" points="0 0 16 0 16 16 0 16" />
        <polygon
          id="Stroke-2"
          :fill="color"
          fill-rule="evenodd"
          points="14.9394709 3.93992237 15.6465291 4.64707763 8 12.2925583 0.353470851 4.64707763 1.06052915 3.93992237 8 10.8784417"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1D1D1D'
    }
  }
};
</script>
